<template src='./dashboard.pug' lang='pug'></template>

<script>
import moment from 'moment'
import vSelect from 'vue-select'
import Draggable from 'vuedraggable'
import HeaderBar from '../layout/headerBar/HeaderBar'
import DateRange from '../input/dateRange/DateRange'
import Chart from './chart/Chart'
import { debounce as _debounce } from '../../utils/helpers'
import FiltroPeriodoEnum from '../../enum/filtroPeriodo'

export default {
  name: 'Dashboard',

  components: {
    vSelect,
    Draggable,
    HeaderBar,
    DateRange,
    Chart
  },

  props: {
    charts: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      debounce: _debounce.apply(this),
      finalDateDisable: moment(new Date()).add(1, 'days').toDate(),
      dateRange: {},
      firstDate: moment(new Date()).add(-31, 'days').toDate(),
      finalDate: moment(new Date()).toDate(),
      filter: {
        periodType: {}
      },
      periodList: [
        {
          id: FiltroPeriodoEnum.ESTA_SEMANA,
          label: this.$t('dashboard.filtro.data.estaSemana')
        },
        {
          id: FiltroPeriodoEnum.ULTIMOS_SETE_DIAS,
          label: this.$t('dashboard.filtro.data.ultimosSeteDias')
        },
        {
          id: FiltroPeriodoEnum.ESTE_MES,
          label: this.$t('dashboard.filtro.data.esteMes')
        },
        {
          id: FiltroPeriodoEnum.ULTIMOS_TRINTA_DIAS,
          label: this.$t('dashboard.filtro.data.ultimosTrintaDias')
        },
        {
          id: FiltroPeriodoEnum.MES_ANTERIOR,
          label: this.$t('dashboard.filtro.data.mesAnterior')
        },
        {
          id: FiltroPeriodoEnum.PERSONALIZADO,
          label: this.$t('dashboard.filtro.data.personalizado')
        }
      ]
    }
  },

  computed: {
    availableGadgets () {
      return this.$store.getters.availableGadgets
    }
  },

  methods: {
    setCustomRangeFilter () {
      if (!this.dateRange.invalid) {
        this.filter.fromDate = this.dateRange.fromDate
        this.filter.toDate = this.dateRange.toDate
        this.$store.dispatch('setDashboardDateFilter', {id: this.filter.periodType.id, label: this.filter.periodType.label, fromDate: this.dateRange.fromDate, toDate: this.dateRange.toDate})
      }
    },

    onPeriodChanged (period) {
      if (FiltroPeriodoEnum.PERSONALIZADO !== period.id) {
        this.$store.dispatch('setDashboardDateFilter', {id: period.id, label: period.label})
      }
      this.filter.periodType = period
    },

    resize (index, chart) {
      if (chart.container === 'chartFull') {
        chart.container = 'chartMiddle'
      } else {
        chart.container = 'chartFull'
      }
      this.charts.splice(index, 1, chart)
      this.saveDashboard()
    },

    saveDashboard () {
      for (const [index, chart] of this.charts.entries()) {
        if (!chart) {
          continue
        }
        for (const gadget of this.availableGadgets) {
          if (gadget && gadget.gadgetParam && gadget.gadgetParam.length > 0) {
            let paramOrderAux = gadget.gadgetParam.find(param => param.nome === 'ordemExibicao')
            let paramContainerAux = gadget.gadgetParam.find(param => param.nome === 'container')
            if (chart.idChart === gadget.funcionalidade.idFuncionalidade) {
              paramOrderAux.valor = index + 1
              paramContainerAux.valor = chart.container === 'chartFull' ? 1 : 2
            }
          }
        }
      }
      this.debounce(this.setGadgetConfig, 2500)
    },

    configChartShow (chart) {
      return chart && chart.idChart ? this.$store.getters.allowedFuncionalities.includes(chart.idChart) : null
    },

    setGadgetConfig () {
      this.$store.dispatch('updateGadgetList', this.availableGadgets)
    },

    showDateRange () {
      return FiltroPeriodoEnum.PERSONALIZADO === this.filter.periodType.id
    }
  },

  created () {
    this.filter.periodType = this.periodList.find(item => {
      return item.id === this.$store.getters.periodDashboard.id
    })
  },

  beforeDestroy () {
    this.setGadgetConfig()
  }
}
</script>

<style lang="scss">
.sortable-chosen, .sortable-ghost {
  background: none !important;
  background-color: transparent !important;
  max-width: 100% !important;
  min-width: 50% !important;
  content: '';
  opacity: 0.5 !important;
  transition: all .2s !important;
}

.list-complete-enter,.list-complete-leave-active {
  background: red;
}

.chart-item {
  margin-bottom: 50px;
}

.style-chooser {
  width: 13vw;
  float: left;
  margin-right: 15px;
}

.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: flex;
  padding: 0 0 4px;
  background: none;
  border: 1px solid rgba(60,60,60,.26);
  border-radius: 4px;
  white-space: normal;
  background: white;
}

.col-per-83 {
  width: 83%;
}

.col-per-17 {
  width: 17%;
}

.col-per-100 {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?fd937e9e